import { InjectionToken } from '@angular/core';
import { Environment } from './providers/config.service';

export interface PicflowConfig {
  apiEndpoint: string;
  socketEndpoint: string;
  authClientID: string;
  authDomain: string;
  intercomAppId: string;
  _assetsEndpoint: string;
  filesEndpoint: string;
  stripePublishableKey: string;
  customerIoSiteId: string;
  env: Environment;
  origin: string;
  gtmWorkspaceId: string;
  gtmEnvironmentExtra: string;
  segmentKey: string;
  isTenantDomain: boolean;
  customDomainCnameValue: string;
  lightroomAuthClientId: string;
  growthBookKey: string;
  assetsEndpoint: string;
  useAbsoluteUrls: boolean;
  correctPicflowUrl: string;
  translationBase: string;
  internalApiUrlBase: string;
  version: string;
  captureOneLocalHost: string;
}

export const PICFLOW_CONFIG = new InjectionToken<PicflowConfig>('PicflowConfig');
